import { Link as ChakraLink, Box, Text, css } from "@chakra-ui/react"
import { ChevronRightIcon } from "@chakra-ui/icons"
import { Link } from "gatsby"
import React from "react"

const ctaCss = css({
  fontSize: 24,
  fontWeight: 500,
  textTransform: `uppercase`,
  outline: '0px',
  fontFamily: "heading",
  ":hover": {
    textDecoration: `underline`,
  },
})

const ctaSmallCss = css({
  fontSize: 24,
  fontWeight: 500,
  color: `white`,
  textTransform: `uppercase`,
  fontFamily: "heading",
  ":hover": {
    textDecoration: `underline`,
  },
})

export function CTA({
  direction,
  cta,
  large,
  color,
  ctaLink,
  fontSize,
  internalLink = true,
}) {
  let link
  if (internalLink) {
    link = (
      <Link
        to={ctaLink}
        css={large ? ctaCss : ctaSmallCss}
        style={color && large && { color, fontSize }}
      >
        {cta}
      </Link>
    )
  } else {
    link = (
      <ChakraLink
        href={ctaLink}
        target="_blank"
        css={large ? ctaCss : ctaSmallCss}
        style={{ color }}
        fontSize={fontSize}
      >
        {cta}
      </ChakraLink>
    )
  }

  return (
    <Box
      maxWidth={direction === `center` ? "200px" : `100%`}
      textAlign={{
        base: direction === `center` ? `center` : `left`,
        lg: direction === `center` ? `center` : "left",
      }}
      margin="0 auto"
      _hover={
        ctaLink && {
          textDecoration: `underline`,
          "> span": {
            marginLeft: "15px",
          },
        }
      }
    >
      {ctaLink ? (
        <React.Fragment>
          {link}
          <Box as="span" fontSize="24px">
            <ChevronRightIcon color={color} />
          </Box>
        </React.Fragment>
      ) : (
        <Text
          color="black"
          fontFamily="heading"
          fontSize="24px"
          fontWeight="500"
          textAlign="center"
        >
          {cta}
        </Text>
      )}
    </Box>
  )
}
